import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { fetchMonitorGroups, monitorLogout } from "../../api/client";
import "../shared/MonitorFlowPage.css";

export default function GroupListPage() {
  const navigate = useNavigate();
  const [groups, setGroups] = React.useState([]);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    let mounted = true;

    fetchMonitorGroups()
      .then((data) => {
        if (!mounted) return;
        setGroups(data.groups || []);
      })
      .catch((loadError) => {
        if (!mounted) return;
        setError(loadError.message || "그룹 목록을 불러오지 못했습니다.");
        navigate("/login", { replace: true });
      });

    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handleLogout = async () => {
    await monitorLogout();
    navigate("/login", { replace: true });
  };

  return (
    <AppShell
      title="그룹 목록"
      subtitle="old 흐름처럼 먼저 전체 그룹을 보고, 그룹별로 디바이스 목록으로 들어갑니다."
      actions={<button className="action-btn" onClick={handleLogout} title="로그아웃">
        <svg viewBox="-8 -5 40 30" preserveAspectRatio="none" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 6.5C2 4.01472 4.01472 2 6.5 2H12C14.2091 2 16 3.79086 16 6V7C16 7.55228 15.5523 8 15 8C14.4477 8 14 7.55228 14 7V6C14 4.89543 13.1046 4 12 4H6.5C5.11929 4 4 5.11929 4 6.5V17.5C4 18.8807 5.11929 20 6.5 20H12C13.1046 20 14 19.1046 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 20.2091 14.2091 22 12 22H6.5C4.01472 22 2 19.9853 2 17.5V6.5ZM18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929L19.5858 13L11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11L19.5858 11L18.2929 9.70711C17.9024 9.31658 17.9024 8.68342 18.2929 8.29289Z" fill="#0F1729"/>
        </svg>
      </button>}
    >
      <div className="flow-grid">
        {error ? <div className="error-box">{error}</div> : null}
        <section className="card">
          <div className="card__header">
            <h2>전체 그룹</h2>
          </div>
          <div className="card__body">
            {!groups.length ? (
              <div className="empty-state">등록된 그룹이 없습니다.</div>
            ) : (
              <div className="group-list">
                {groups.map((group) => (
                  <article key={group.group_code} className="group-card">
                    <Link to={`/monitor/groups/${group.group_code}`}>
                      <strong>{group.name}</strong>
                      <div className="meta-row">
                        <span>{group.group_code}</span>
                        <span>디바이스 {group.device_count}개</span>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </AppShell>
  );
}
